<template>
  <div class="top">
    <div class="nav">
      <div class="nav-bottom"></div>
      <div class="nav-left">
        <div class="logo"></div>
        <div class="nav-title">校园大脑IOC</div>
        <!-- <div class="icon">
          <div class="icon-top">2021年全国行业职业技能竞赛</div>
          <div class="icon-bottom">第四届全国智能制造应用技术技能大赛</div>
        </div> -->
      </div>
      <ul v-if="this.$store.state.idbottom" class="header-nav">
        <!-- :class="flag ? 'nav-center active' : 'nav-center'" -->
        <li @click="active()" class="nav-center">态势全感知</li>
        <li @click="active()" class="nav-center">学生全发展</li>
        <li @click="active()" class="nav-center">协同全调度</li>
        <li @click="active()" class="nav-center">智能全决策</li>
        <li @click="active()" class="nav-center">校园活动服务</li>
      </ul>
      <div class="header-nav-title" v-if="this.$store.state.idbottom">
        <div class="header-nav-txt">2021年全国行业职业技能竞赛</div>
        <div class="header-nav-txt1">——第四届全国智能制造应用技术技能大赛</div>
          <div class="header-nav-bottom">
            <div class="ico-right"></div>
            <div class="ico-left"></div>
          </div>
      </div>
      <div class="nav-right">
        <div class="nav-right1">
          <div class="time">
            <span class="time-bg"></span>
            <span class="period">{{ hour }}</span>
            <span class="year">{{ year }}</span>
            <span class="day">{{ day }}</span>
          </div>
          <div class="weather">
            <span
              class="weather-bg"
              :style="{ backgroundImage: 'url(' + this.weatherBg + ')' }"
            ></span>
            <span>{{ weather }}</span>
            <span>{{ temperature }}</span>
          </div>
        </div>
        <div class="title">
        重庆木棉树软件开发有限公司
        </div>
      </div>
    </div>
    <!-- <div class="back"></div> -->
  </div>
</template>

<script>
export default {
  name: "homeHeader",
  data() {
    return {
      year: "",
      hour: "",
      timer: "",
      weather: "晴天",
      temperature: "25℃",
      flag: false,
      day: "",
      weatherBg: require("./../assets/img/sunny.png"),
      type: "",
    };
  },
  created() {
    this.getTime();
    this.timer = setInterval(this.getTime, 1000);
    this.getWeather();
  },
  mounted() {
    window.addEventListener("message", (e) => {
      // console.log(e);
      if (e.data.type != "webpackClose") {
        this.type = e.data.type;
      }
    });
  },
  methods: {
    getTime() {
      // eslint-disable-next-line no-unused-vars
      const myDate = new Date();
      // eslint-disable-next-line no-unused-vars
      const year = myDate.getFullYear();
      const month = myDate.getMonth() + 1;
      const date = myDate.getDate();
      let days = myDate.getDay();
      switch (days) {
        case 1:
          // eslint-disable-next-line no-const-assign
          days = "星期一";

          break;

        case 2:
          // eslint-disable-next-line no-const-assign
          days = "星期二";

          break;

        case 3:
          // eslint-disable-next-line no-const-assign
          days = "星期三";

          break;

        case 4:
          // eslint-disable-next-line no-const-assign
          days = "星期四";

          break;

        case 5:
          // eslint-disable-next-line no-const-assign
          days = "星期五";

          break;

        case 6:
          // eslint-disable-next-line no-const-assign
          days = "星期六";
          break;
        case 0:
          // eslint-disable-next-line no-const-assign
          days = "星期日";

          break;
      }
      let hours = myDate.getHours();
      let minute = myDate.getMinutes();
      let second = myDate.getSeconds();

      // eslint-disable-next-line no-const-assign
      hours = hours >= 10 ? hours : "0" + hours;

      // eslint-disable-next-line no-const-assign
      minute = minute >= 10 ? minute : "0" + minute;

      // eslint-disable-next-line no-const-assign
      second = second >= 10 ? second : "0" + second;
      this.year = year + "-" + month + "-" + date;
      this.day = days;
      this.hour = hours + ":" + minute + ":" + second;
    },
    active() {
      this.flag = !this.flag;
    },
    getWeather() {
      this.$axios
        .get("http://wthrcdn.etouch.cn/weather_mini?city=德阳", {})
        .then((response) => {
          // console.log(response);
          this.temperature = response.data.data.wendu + "℃";
          this.weather = response.data.data.forecast[0].type;
          if (this.weather == "晴") {
            this.weatherBg = require("./../assets/img/sunny.png");
          } else if (this.weather == "阴") {
            this.weatherBg = require("./../assets/img/partly-cloudy.png");
          } else if (this.weather == "多云") {
            this.weatherBg = require("./../assets/img/cloudy-day.png");
          } else if (this.weather == "小雨") {
            this.weatherBg = require("./../assets/img/light-rain.png");
          } else {
            this.weatherBg = require("./../assets/img/temperature.png");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.top {
  height: 6.5vh;
  width: 100%;
  position: relative;
  background: url("./../assets/img/top.png") no-repeat;
  background-size: 100% 75%;
  z-index: 999;
}
.nav {
  height: 6.5vh;
  width: 100%;
  position: relative;
  /* border: 1px solid red; */
}
.nav-bottom {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 41%;
  background: url("./../assets/img/nav-bg.png") no-repeat;
  background-size: 100% 100%;
}
.nav-left {
  position: absolute;
  box-sizing: border-box;
  height: 85%;
  width: 38%;
  font-family: "SourceHanSansCN";
  font-size: 0.3rem;
  padding-left: 0.3rem;
  color: rgb(255, 255, 255);
  overflow: hidden;
  white-space: nowrap;
  display: flex;
  justify-items: center;
  align-items: center;
}
.nav-left .logo {
  width: 0.5rem;
  height: 0.5rem;
  background: url("./../assets/img/logo.png") no-repeat;
  background-size: 100% 100%;
}
.nav-left .nav-title {
  height: 70%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 0.15rem;
  font-size: 0.4rem;
  letter-spacing: 0.05rem;
  margin-right: 0.2rem;
  background-image: -webkit-linear-gradient(bottom, #7db2ff, #ffffff 67%);
  -webkit-background-clip: text;
  color: transparent;
  font-weight: 700;
}
.nav-left .icon {
  font-size: 0.21rem;
  letter-spacing: 0.03rem;
  font-weight: 500;
  height: 100%;
  background-image: -webkit-linear-gradient(bottom, #7db2ff, #ffffff);
  -webkit-background-clip: text;
  color: transparent;
  font-weight: 700;
}
.nav-left .icon .icon-top {
  height: 45%;
}
.nav-left .icon .icon-bottom {
  height: 43%;
}
.nav-right {
  position: absolute;
  right: 1.5%;
  width: 21%;
  font-family: "SourceHanSansCN";
  font-size: 0.2rem;
  color: #ffffff;
  overflow: hidden;
  white-space: nowrap;
}
.nav-right1 {
  display: flex;
  justify-content: space-between;
  justify-items: center;
  height: auto;
}
.nav-right .title {
  width: auto;
  font-size: 0.3rem;
  display: flex;
  justify-content: center;
  justify-items: center;
  position: relative;
  float: right;
  padding-right: .083333rem;
}
.nav-right .time {
  /* width: 2.9rem; */
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.nav-right .time span {
  margin-right: 0.083333rem;
}
.nav-right .time .period {
  margin-right: 0.333333rem;
}
.nav-right .time .year {
  margin-right: 0.333333rem;
}
.nav-right .time .time-bg {
  display: inline-block;
  width: 18px;
  height: 18px;
  background: url("./../assets/img/time.png");
  background-size: 100% 100%;
}
.nav-right .weather {
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.nav-right .weather .weather-bg {
  display: inline-block;
  width: 27px;
  height: 27px;
  margin-right: 0.0625rem;
  background-size: 100% 100%;
}
.nav-right .weather span {
  margin-right: 0.0625rem;
}
.nav-center {
  width: 1.475rem;
  height: 100%;
  background: url("./../assets/img/headerNo-nav.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-family: "SourceHanSansCN";
  font-size: 0.175rem;
  color: #deedff;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
}
.nav .active {
  background: url("./../assets/img/header-nav-active.png") no-repeat;
  background-size: 100% 100%;
  color: #ffeab2;
}
.header-nav {
  position: absolute;
  top: 4vh;
  width: 35vw;
  left: 50%;
  transform: translateX(-50%);
  height: 50%;
  display: flex;
  justify-content: space-around;
}
.header-nav li:last-child {
  background: url("./../assets/img/header-nav.png") no-repeat;
  background-size: 100% 100%;
}
.back {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0.5%;
  width: 20px;
  height: 20px;
  background: url("./../assets/img/back.png") no-repeat;
  background-size: 100% 100%;
}
.title-logo {
  display: inline-block;
  width: 0.3rem;
  height: 0.3rem;
  background: url("./../assets/img/nav-title-logo.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: -0.4rem;
  top: 50%;
  transform: translateY(-50%);
}
.header-nav-title {
  position: absolute;
  top: 11vh;
  width: 37vw;
  left: 50%;
  transform: translateX(-50%);
  height: auto;
   overflow: hidden;
  white-space: nowrap;
  font-family: 'SourceHanSansCN';
  font-weight: 1000;
}
.header-nav-txt {
  width: 100%;
  text-align: center;
  font-size: 0.35rem;
  color: #163cad;
 letter-spacing:.295rem;
}
.header-nav-txt1 {
   width: 100%;
  /* text-align: center; */
  letter-spacing:-3px;
  font-size: 0.35rem;
  color: #163cad;
  letter-spacing: 10px;
}
.header-nav-bottom{
  display: flex;
  justify-content:center;
  margin-top: .166667rem;
}
.ico-right{
  width: 0.9rem;
  height: 0.9rem;
  background: url("./../assets/img/ico-right.png") no-repeat;
  background-size: cover;
  margin-right: .166667rem;
}
.ico-left{
   width: 0.9rem;
  height: 0.9rem;
  background: url("./../assets/img/ico-left.png") no-repeat;
  background-size: cover;
   margin-left: .166667rem;
}
</style>